module.exports = __webpack_public_path__ + "img/filter.3e89c669.svg";